import moment from 'moment';

export default class DateUtils {

  static buildDate(date) {
    if (!date){
      return date;
    }
    return new Date(new Date(date.getTime() - (60*1000 * date.getTimezoneOffset())).toISOString().substring(0,10));
  }

  static buildDateFromString(date) {
    if (!this.isValidDate(date)){
      return null;
    }
    const d = moment(date,'DD/MM/YYYY');
    const newDate = new Date(d.format('YYYY'), d.format('M') - 1, d.format('D'));
    return this.buildDate(newDate);
  }

  static isValidDate(date) {
    if (date){
      if (typeof date === 'string') {
        const d = moment(date,'DD/MM/YYYY');
        if(d == null || !d.isValid()) {
          return false;
        }
        return date.indexOf(d.format('DD/MM/YYYY')) >= 0;
      }
      return moment(date).isValid();
    }
    return false;
  }

  static formatDateString(date){
    let result = '';
    for (let x = 0; x < date.length; x++) {
      const char = date.charAt(x);
      if (!isNaN(parseInt(char, 10)) || char === '/') { // Is a number or /
        result += char;
      }
    }
    return result;
  };

}


// WEBPACK FOOTER //
// ./src/app/shared/utils/DateUtils.js